import { Component, Input } from '@angular/core';
import { AdminService } from '../../admin.service';

@Component({
  selector: 'app-display-array-embedded',
  template: require('./display-array-embedded.component.html'),
  styles: [require('./display-array-embedded.component.scss')],
})
export class DisplayArrayEmbeddedComponent {
  @Input() value: any;
  @Input() key: string;

  constructor(
    public adminService: AdminService,
  ) { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/display-array-embedded/display-array-embedded.component.ts